import { useLocation, useNavigate } from "react-router-dom";

export function usePaginationQuery() {
  const location = useLocation();
  const navigate = useNavigate();

  function setQueryParams(next, replace = false) {
    const params = new URLSearchParams(location.search);

    if (next.page !== undefined && next.page !== null) {
      params.set("page", String(next.page));
    }

    if (next.filtro !== undefined) {
      const f = String(next.filtro || "").trim();
      if (f) params.set("filtro", f);
      else params.delete("filtro");
    }

    const qs = params.toString();
    navigate(`${location.pathname}${qs ? `?${qs}` : ""}`, { replace });
  }

  return { setQueryParams };
}
